var _defs, _image, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgdIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 53.8,
    viewBox: "0 0 520 538",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        font-size: 125px;\n        filter: url(#filter);\n        fill: #fff;\n        font-family: \"Franklin Gothic Medium\";\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "filter",
    x: 77,
    y: 61,
    width: 357,
    height: 138,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    in2: "SourceGraphic"
  })))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: 4,
    y: 4,
    width: 512,
    height: 530,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAA1CAYAAADs+NM3AAAC0UlEQVRoge2a3YtOQRzHP89ahEgiFCFlSRY3SoorV16KC/+AP8KVvORCIVdcSN4ulIS8S97fy1s2PUTkgmiJbLtLWKup3zzNTjPnzHl29+wce7419cw535nn9zlnZjrzO6cC7ALWAw0UW8cVTHfBIWpqBDqBkcBX4GkkcWVREzAF6FBt2uTunC9M+D21Q+JvM+fJsBgiq0MjdBMTplKEyB2qMRR9BeuhNJihwPCcY6pbjSnn/xZp6U6D6copjj7RoJozhVIJE6tKmFhVwsSqEiZWlTCx6r+CSXtq1loCzAT+9H9IXg0BfgCXgHaXKQRmInAnn3iDtAXY7DKGwHwHtgFTBzhPoDaJv4FTPkMIzE9gY9/G1T8qV7NYNeiW5tHAUWBSDvEkqSILwAbglssXAqPSnytzCzldTb2BaQUmA9MljzZQapA3Fi2+/w99AvgkJWqVq1msCh1mE4DmnBmqwMcsDUJhrgNz64upbrXKQ26wQmH2A2tyfiNwpZ5G+p1mXY0j0F7XO83Cq4SJVSZMR0EZvukfJoxKWKzO0MmCDN75GbyzMqyyi4GF5gG9mulyJqCTi+K9HOC9J97DAd6t4q3KJzBJ2m7F3eaCUeVsQidXLe+1BO/tDBdqp+V9AYzxeG2QGkyX40S3IwtScQSXBGRD63JTcmCm9ni8r4FxASCq/EKyL6ryEFguqSVtOGl08sg43iIbtg8eoAvG8Vfy9PDeOPbM8B6wgloHnDbq74BRHpC1wAmjzjIZq+OlwWzJGGrDQZkbuv4SGCveacBn49wRYJ9R/yKfTyEbvDfGubvAISu4pZ6Lpy70bsurd79qsdgErPIMSeYYd8wsVcc4toF0UXd4huVVbZ94hsgiy6uG4n3PkMq8jW+2gB6bn0OlAHXKXt0lFeQNw9uesr1Qc6xXIFrzgOcyzOxJ6wJ6K3NDtUvTMeBBArSpc9L3Cq8D+AdP1e+9vAe6mQAAAABJRU5ErkJggg=="
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "BDG",
    className: "cls-1",
    transform: "translate(66 194.266) scale(1.541)"
  }, "BDG")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgdIcon);
export default __webpack_public_path__ + "static/media/bgd-icon.6e1217e3714189a1cc81c504d5b30b09.svg";
export { ForwardRef as ReactComponent };